// Konstante für Debug-Domains
const DEBUG_DOMAINS = ['ethemis.local', 'ethemis.dev'];

//             'Wenn du Javascript anpassen möchtest, dann gehe zu erst unter src/webpack.config.js und aktiviere den Compiler!'
//             'ENABLE_WEBPACK = FALSE;'
//             'Wenn du mit dem entwickeln fertig bist und deine anpassungen kompiliert sind, schalte es wieder auf FALSE! '
//
//             'Debug-Modus ist deaktiviert um Spam in der Konsole zu vermeiden.'
//             'Aktiviere ihn in der Konfiguration der utils.js unter src/js/components/utils.js:'
//             'ENABLE_DEBUG = TRUE;'

// Debug-Modus aktivieren oder deaktivieren
const ENABLE_DEBUG = false;

// Debug-Logger
// @TODO: Skriptname von Dateinamen entnehmen
export const consoleLog = (scriptName, message, data = null) => {
    if (ENABLE_DEBUG && DEBUG_DOMAINS.includes(window.location.hostname)) {
        console.log(`[${scriptName}] ${message}`, data || '');
    }
};

/** Aktuelle Seite aus URL bestimmen */
export const getCurrentPage = (pages) => {
    const PATH = window.location.pathname;
    return pages.find((page) => PATH.includes(`/${page}`)) || null;
};

/** Sprachtext abrufen */
export const getLanguageText = (key) => {
    if (!window.__LANG__) {
        console.warn(`Sprachdaten nicht gefunden`);
        return key;
    }
    return window.__LANG__[key] || key;
};
